import DashboardIcon from '@mui/icons-material/Dashboard'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SensorsIcon from '@mui/icons-material/Sensors'
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { dashboardPath } from './dashboardPath'
import { useSiteLiveDashboards } from './useSiteLiveDashboards'

/** Sidebar section listing the current site's cloud dashboards; hidden when the site has none. */
const DashboardsContainer = ({
  isOpen = true,
  onOpen,
  onClose,
}: {
  isOpen?: boolean
  onOpen?: () => void
  onClose?: () => void
}) => {
  const { t } = useTranslation()
  const location = useLocation()
  const { data: dashboards = [] } = useSiteLiveDashboards()
  const [expanded, setExpanded] = useState(true)

  if (dashboards.length === 0) return null

  return (
    <List>
      <Tooltip title={!isOpen ? t('dashboards.dashboards') : ''} placement="right">
        <ListItemButton
          onClick={() => (isOpen ? setExpanded((prev) => !prev) : onOpen?.())}
          selected={dashboards.some((d) => location.pathname === dashboardPath(d.Id))}
        >
          <ListItemIcon>
            <DashboardIcon htmlColor="black" />
          </ListItemIcon>
          {isOpen && <ListItemText primary={t('dashboards.dashboards')} />}
          {isOpen && (expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
        </ListItemButton>
      </Tooltip>
      <Collapse in={isOpen && expanded} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {dashboards.map((dashboard) => (
            <ListItemButton
              key={dashboard.Id}
              selected={location.pathname === dashboardPath(dashboard.Id)}
              component={Link}
              to={dashboardPath(dashboard.Id)}
              onClick={onClose}
              sx={{ pl: 4 }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <SensorsIcon fontSize="small" htmlColor="black" />
              </ListItemIcon>
              <Tooltip title={dashboard.Name} placement="right" enterDelay={500}>
                <ListItemText primary={dashboard.Name} primaryTypographyProps={{ noWrap: true }} />
              </Tooltip>
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </List>
  )
}

export default DashboardsContainer
